/**
 * Recovers a page whose build is gone. Each deploy's image serves only its own hashed chunks, so a page loaded before
 * a deploy (or from a cache that kept the old page) fails when it next loads a chunk lazily: the world's sponsor props,
 * a route's screen. Vite reports that as `vite:preloadError`; the page reloads once onto the new build instead of
 * showing a broken part. A second failure soon after is a chunk that's really missing, so it's left to throw.
 */

const KEY = 'streambridge:stale-chunk-reload'
/** A reload within this long of the last one doesn't happen again. */
const QUIET_MS = 60_000

export function reloadOnStaleChunks(target: Window = window): void {
  target.addEventListener('vite:preloadError', (event) => {
    const now = Date.now()
    try {
      const last = Number(target.sessionStorage.getItem(KEY))
      if (last && now - last < QUIET_MS) return
      target.sessionStorage.setItem(KEY, String(now))
    } catch {
      // No session storage (a private window, a blocked origin): reload anyway; the browser's own fetch stops a loop.
    }
    event.preventDefault()
    target.location.reload()
  })
}
